import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from "react-router-dom";
import DynamicMrtcomponent from "./components/dynamic-router/dynamicMrtComponent.js";
import DynamicClientComponent from "./components/dynamic-router/dynamicClientComponent.js";
import MrtHomePage from "./components/mrt-home-page/mrt-home-page.js";
import ErrorPage from"./components/common/error-page/error-page.js";
import { DataProvider } from "./DataContext";

const ClientRoute = () => {
  const { clientCode } = useParams();
  if (clientCode === 'mrt') {
      return <Navigate to="/mrt" />;
  }
  return <DynamicClientComponent />;
};

function App() {
  return (
    <DataProvider>
      <Router>
        <Routes>
        <Route path="/" element={<MrtHomePage />} />
        <Route path="/mrt" element={<DynamicMrtcomponent />} />
        <Route path="/mrt/:id" element={<DynamicMrtcomponent />} />
        <Route path="/:clientCode" element={<ClientRoute />} />
        <Route path="/:clientCode/index.html" element={<ClientRoute />} />
        <Route path="/error" element={<ErrorPage />} />
        </Routes>
      </Router>
    </DataProvider>
  );
}

export default App;
